const styles = theme => ({
  root: {
    borderRadius: 2
  },
  deleteIcon: {
    color: theme.palette.grey[600],
    width: '1rem',
    height: '1rem'
  },
  label: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2)
  }
});

export default styles;
